import { forwardRef } from 'react';
import MAIN from './components/MAIN';

//TODO átnevezni az importálást
function Test(props: any, ref: any) {
	const _props = {};
	return <MAIN {...props} {..._props} />;
}

export default forwardRef(Test);
